import TileNotification from "./TileNotification";
//import {useLoaderData} from "react-router-dom";
import Notification from "app/models/Notification";
import { AiFillCloseCircle } from "react-icons/ai";

export default function Notifications({ notifications, close }: { notifications: Notification[], close: () => void }) {

    return (
        <>
            <div className="section-title"
                style={{
                    position: "relative",
                    padding: "10px 5px",
                }}>
                NOTIFICHE
                <div onClick={close} style={{
                    position: "absolute",
                    top: "3px",
                    right: "5px",
                    cursor: "pointer",
                    fontSize: "20px",
                    color: "#DC143C"
                }}>
                    <AiFillCloseCircle />
                </div>
            </div>

            <div
                style={{
                    maxHeight: "161px",
                    overflowY: "scroll",
                    borderRadius: "10px",
                }}
            >
                {notifications?.map((notification) => <TileNotification key={notification?.id} notification={notification} />)}
            </div>

        </>
    )
}


